/**
 * The hike map's active view — whole hike, one day, or one route — as emitted
 * by HikeTrailsPanel's `view-changed` and held by HikeMap.vue.
 */
export interface HikeMapView {
  type?: 'full' | 'day' | 'route' | string;
  dayNumber?: number;
  trailId?: string | number | null;
}

/** The panel's string key for a view: 'full', 'day-<n>' or 'route-<id>'. */
export function viewKey(view: HikeMapView | null | undefined): string {
  if (view?.type === 'route') return `route-${view.trailId}`;
  if (view?.type === 'day') return `day-${view.dayNumber}`;
  return 'full';
}

/**
 * Whether the elevation profile offers a "back to the whole hike" button, as
 * the planner's does: only from a day or route view, and only when the hike
 * has more than one route to go back to (same condition as the panel's own
 * full-hike button).
 */
export function showBackToFullHike(view: HikeMapView | null | undefined, routeCount: number): boolean {
  return viewKey(view) !== 'full' && routeCount > 1;
}
